@import (reference) '../../../../../constants/spacing.module.less';

.cost-summary-container {
  margin: @space-16 @space-16 @space-0;
  padding-bottom: @space-16;
}

.cost-summary-header {
  padding-bottom: @space-8;
}

.divider {
  margin-top: @space-16;
  border-color: var(--gray-DFE4E8);
}

.cost-summary-values {
  align-items: flex-end;
}

.cost-summary-row {
  justify-content: flex-end;
}

.cost-summary-label {
  font-weight: 600;
  font-size: 14px;
  color: var(--grey-700);
}

.cost-summary-value {
  font-weight: 600;
  font-size: 14px;
  width: 120px;
  text-align: right;
}
